import { ApiResult, request, safeRequest } from '@synergy/api';

export class changePasswordApi {
    constructor(protected baseUrl: string) {}

    public changePassword = (currentPassword: string, newPassword: string): Promise<ApiResult<void>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/change-password`, { currentPassword, newPassword }),
            response => response.data
        );
    };
}
